/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import { variantIcons } from 'ui/designSystem/Tag/Tag.variants'
import { TagProps, TagVariant } from 'ui/designSystem/Tag/types'

export function getTagIcon(variant: TagVariant, icon?: TagProps['Icon']): TagProps['Icon'] {
  const forcedVariants = [
    TagVariant.BOOKCLUB,
    TagVariant.CINECLUB,
    TagVariant.SCENECLUB,
    TagVariant.HEADLINE,
    TagVariant.LIKE,
  ]
  return forcedVariants.includes(variant) ? variantIcons[variant] : icon
}
